import React from 'react';
import PropTypes from 'prop-types';
import BroadcastToFacebookForm from '../../Forms/BroadcastToFacebookForm';
import fetch from 'isomorphic-fetch';
import Moment from 'react-moment';
import moment from 'moment';
import { connect } from 'react-redux';
import ExploreAuth from '../../../utils/ExploreAuth';
import { checkHttpStatus, parseJSON } from '../../../utils';

const contextTypes = {
  router: PropTypes.object,
};

class BroadcastToFacebookModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      recentBroadcasts: [],
      loading: false,
    };
    this.interval = null
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: true }, () => {
    ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        if (tokenIsValid) {
          fetch(`${SERVER_URL}/broadcast/facebook/recent`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${ExploreAuth.getJwt()}`,
            },
          })
            .then(checkHttpStatus)
            .then(parseJSON)
            .then((response) => {
              if (response.data) {
                this.setState({ recentBroadcasts: response.data, loading: false });
              }
            })
            .catch((error) => {
              console.log(error, 'An error occurred');
              this.setState({ loading: false });
            });
        }
      });
    });
  }

  closeModal(e) {
    this.props.removeModal();
  }

  render() {
    const { loading, recentBroadcasts } = this.state;
    const { isLive } = this.props;
    const interval = 100;

    function isLiveNow(starting, end) {
      const now = moment();
      if (end.isBefore(now)) {
        return 'Ended';
      }
      if (now.isBetween(starting, end)) {
        return 'Live';
      }
    }

    const isCurrentlyBroadcastingFilter = (starting, d) => {
      const end = moment(d);
      return isLiveNow(starting, end);
    };
    return (
      <div>
        <div className="modals-popup reset-password-modal">
          <div className="modal-header d-flex align-items-center">
            <div className="col">Broadcast on Facebook Live</div>
            <div className="text-right">
              <a className="closer" href="#" onClick={this.closeModal}></a>
            </div>
          </div>

          <div className="info">
            <div className="p-20">
              <div className="px-3">
              {!isLive && (
                <div className="alert alert-primary">
                  This stream is currently in highlights or meditation mode. Are you sure you want to send it to Facebook?
                </div>
              )}
              {!loading && recentBroadcasts.length > 0 && (
                <div>
                  <strong>Recent Facebook Live Broadcasts</strong>
                  <table className="table table-bordered table-sm">
                    <thead>
                    <tr>
                      <th>Status</th>
                      <th>Start</th>
                      <th>End</th>
                      <th>Livecam</th>
                      <th>Facebook Page</th>
                    </tr>
                    </thead>
                    <tbody>
                    {recentBroadcasts.map((broadcast) => {
                      const starting = moment(broadcast.startsAt);
                      const ends = moment(broadcast.startsAt).add(broadcast.duration, 'seconds');
                      const className = isLiveNow(starting, ends) === 'Live' ? 'live-now text-primary' : '';
                      return (
                        <tr key={broadcast.id}>
                          <td className="align-middle">
                            <Moment
                              className={className}
                              interval={interval}
                              filter={(d) => isCurrentlyBroadcastingFilter(starting, d)}
                            >
                              {ends}
                            </Moment>
                          </td>
                          <td className="align-middle">
                            <Moment format="hh:mm A" interval={interval}>{broadcast.startsAt}</Moment>
                          </td>
                          <td className="align-middle">
                            <Moment interval={interval} date={ends} fromNow className="uc-first d-block" />
                          </td>
                          <td className="align-middle"><div className="truncate-overflow" style={{ width: 160, whiteSpace: 'nowrap'}}>{broadcast.livecam}</div></td>
                          <td className="align-middle">{broadcast.fbPage}</td>
                        </tr>
                      );
                    })}
                    </tbody>
                  </table>
                </div>
              )}
              </div>
              <BroadcastToFacebookForm closeModal={this.closeModal} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BroadcastToFacebookModal.contextTypes = contextTypes;

const mapStateToProps = (state) => {
  return {
    isLive: state.currentItem.data.isLive,
  };
}

export default connect(mapStateToProps)(BroadcastToFacebookModal);
